import React from "react"
import { HONEYPOT_FIELD } from "../../utils/leadValidation"

/**
 * Off-screen decoy input.
 *
 * Real visitors never see or tab into it, so any value it carries means an
 * automated submission. The server drops those leads.
 */
const HoneypotField = ({ value, onChange }) => (
  <div className="form-trap" aria-hidden="true">
    <label htmlFor={HONEYPOT_FIELD}>Leave this field blank</label>
    <input
      type="text"
      id={HONEYPOT_FIELD}
      name={HONEYPOT_FIELD}
      tabIndex="-1"
      autoComplete="off"
      value={value}
      onChange={onChange}
    />
  </div>
)

export default HoneypotField
